export const NODE_ENV = process.env.REACT_APP_ENVIRONMENT || 'local';
export const DEPLOY_ENV = NODE_ENV === 'local' ? 'test' : NODE_ENV;
export const IS_TEST = DEPLOY_ENV === 'test';
export const APP_KEY = process.env.REACT_APP_APP_KEY;
export const BUILD_DIR = process.env.REACT_APP_BUILD_DIR;
export const CDN_URL = process.env.REACT_APP_CDN_URL;

export const formatDate = (date) => {
    const pad = (n) => n < 10 ? '0' + n : n;
    return date.getFullYear().toString() +
        pad(date.getMonth() + 1) +
        pad(date.getDate()) +
        pad(date.getHours()) +
        pad(date.getMinutes()) +
        pad(date.getSeconds());
};
